import { FC } from 'react';
import { useRouter } from 'next/router';

interface IGlobalError {
  statusCode: number;
  message?: string;
}

const GlobalError: FC<IGlobalError> = ({ statusCode, message }) => {
  const router = useRouter();
  typeof window !== 'undefined' && router.push('/404');

  return (
    <div>
      <h1>
        Error {statusCode}: {message || 'Что-то пошло не так'}
      </h1>
    </div>
  );
};
export default GlobalError;
